import React, { useCallback, useEffect, useState } from "react";

import { faMicrophone, faMicrophoneSlash } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ControlGroupButtonTooltip, ControlGroupIconButton } from "./SharedComponents";

import styles from "./InMeetingControls.module.css";

// Toogle mute is only available for local recordings in the desktop app
export default function ToggleMuteButton() {
	const [isMuted, setIsMuted] = useState(false);

	useEffect(() => {
		window.desktopRecorder?.getMuteStatus().then(({ ok, isMuted }) => {
			if (!ok) return;
			setIsMuted(isMuted);
		});
		window.desktopRecorder?.registerMuteStatusUpdated(newIsMuted => {
			setIsMuted(newIsMuted);
		});
		return () => {
			window.desktopRecorder?.registerMuteStatusUpdated(undefined);
		};
	}, []);

	const onMute = useCallback(() => {
		window.desktopRecorder?.muteRecording();
		setIsMuted(true);
	}, []);

	const onUnmute = useCallback(() => {
		window.desktopRecorder?.unmuteRecording();
		setIsMuted(false);
	}, []);

	return (
		<ControlGroupButtonTooltip content={isMuted ? "Turn on microphone" : "Turn off microphone"}>
			<ControlGroupIconButton onClick={isMuted ? onUnmute : onMute} className={isMuted ? styles.muted : ""}>
				<FontAwesomeIcon icon={isMuted ? faMicrophoneSlash : faMicrophone} className={styles.squareIcon} />
			</ControlGroupIconButton>
		</ControlGroupButtonTooltip>
	);
}
